import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Button,
	notification,
	Modal,
	InputNumber,
	Form,
	Row,
	Col,
	Select,
	DatePicker,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const AddMaterialDeliveredModal = ({
	addModalOpen,
	setAddModalOpen,
	onCloseModal,
	startDate,
}) => {
	const [apiNotification, contextHolder] = notification.useNotification();

	const [loading, setLoading] = useState(false);
	const [optionsCog, setOptionsCog] = useState([]);
	const [plantOptions, setPlantOptions] = useState([]);

	const [form] = Form.useForm();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		if (addModalOpen) {
			getMaterials();
		}
	}, [addModalOpen]);

	const getMaterials = async () => {
		try {
			setLoading(true);

			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;
			const end = `${startDate.year()}-${startDate.month() + 1}-${startDate.date()}`;

			const url =
				api +
				`/materialdelivered/get/list/dates?startDate=${start}&endDate=${end}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push(item.cog._id);
				});
				await getPlants();
				await getCogs(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			setLoading(false);
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getCogs = async (actualCogs = []) => {
		const url = api + "/cog/get/list/logistics";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						// value: `${item._id} ${item.unitOfMeasurement}`,
						label: item.material,
						disabled: actualCogs.includes(item._id),
					});
				});
				setOptionsCog(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			console.error(err.message);
			return null;
		}
	};

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let plantList = [];

				data.payload.map((item) => {
					if (item.name !== "Laredo") {
						plantList.push({
							label: item.name,
							value: item._id,
						});
					}
				});
				setPlantOptions(plantList);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			console.error(err.message);
			return null;
		}
	};

	const onRemoveItem = (removeFunction, name) => {
		let materials = form.getFieldValue("materials");
		if (materials[name] === undefined) {
			removeFunction(name);
		} else if (!materials[name].cog) {
			removeFunction(name);
		} else {
			let cog = materials.at(name).cog;
			let options = optionsCog;
			let index = optionsCog.findIndex((obj) => obj.value === cog);
			options[index].disabled = false;
			setOptionsCog(options);
			removeFunction(name);
		}
	};

	const onChange = (value) => {
		const materials = form.getFieldValue("materials");
		const updatedCogs = materials.map((cog) => {
			if (cog !== undefined && cog.cog === value) {
				// let cogArray = cog.cog.split(" ");
				// console.log(cogArray);
				return {
					...cog,
					measurementUnit: "ton",
					// unit: cogArray[1],
				};
			}
			return cog;
		});
		form.setFieldsValue({ materials: updatedCogs });

		let options = optionsCog;
		let index = optionsCog.findIndex((obj) => obj.value === value);
		options[index].disabled = true;
		options.map((item) => {
			// if (materials.find((o) => o.cog === item.value)) {
			if (updatedCogs.find((o) => o.cog === item.value)) {
				item.disabled = true;
			} else {
				item.disabled = false;
			}
		});
		setOptionsCog(options);
	};

	const onFinish = async (values) => {
		try {
			setLoading(true);
			const formData = {
				materials: values.materials.map((item) => ({
					...item,
					date: dayjs(item.date).toDate(),
				})),
			};

			const url = api + `/materialdelivered/create/list`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = {
				Authorization: `Bearer ${token}`,
			};

			const { data } = await axios.post(url, formData);
			if (data.success) {
				openNotification("success", "Success", data.message);
				form.resetFields();
				setLoading(false);
				onCloseModal();
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to add delivered material",
			);
			console.error(err.message);
			return null;
		}
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	return (
		<Modal
			title={`Add Delivered Material`}
			open={addModalOpen}
			onCancel={() => {
				form.resetFields();
				setAddModalOpen(false);
			}}
			footer={null}
			width={1500}
			centered
		>
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Form.List name="materials">
					{(fields, { add, remove }) => (
						<>
							{fields.map(({ key, name, ...restField }) => (
								<Row key={key} align="middle" gutter={16}>
									<Col span={4}>
										<Form.Item
											{...restField}
											name={[name, "date"]}
											label="Date"
											rules={[
												{
													required: true,
													message: "Missing date",
												},
											]}
										>
											<DatePicker
												size="large"
												style={{ width: "100%" }}
												format={"MM/DD/YYYY"}
												allowClear={false}
											/>
										</Form.Item>
									</Col>
									<Col span={4}>
										<Form.Item
											{...restField}
											name={[name, "plant"]}
											label="Plant"
											rules={[
												{
													required: true,
													message: "Missing plant",
												},
											]}
										>
											<Select
												style={{
													width: "100%",
												}}
												size="large"
												placeholder="Please select plant"
												options={plantOptions}
												optionFilterProp="children"
												filterOption={filterOption}
												allowClear={false}
												showSearch
											/>
										</Form.Item>
									</Col>
									<Col span={4}>
										<Form.Item
											{...restField}
											name={[name, "quantity"]}
											label="Quantity"
											rules={[
												{
													required: true,
													message: "Missing quantity",
												},
											]}
										>
											<InputNumber
												size="large"
												style={{ width: "100%" }}
												formatter={(value) =>
													`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
												}
												parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
											/>
										</Form.Item>
									</Col>
									<Col span={6}>
										<Form.Item
											{...restField}
											name={[name, "cog"]}
											label="Material Delivered"
											rules={[
												{
													required: true,
													message: "Missing material",
												},
											]}
										>
											<Select
												style={{
													width: "100%",
												}}
												size="large"
												placeholder="Please select material delivered"
												options={optionsCog}
												onChange={(e) => onChange(e, name)}
												optionFilterProp="children"
												filterOption={filterOption}
												allowClear={false}
												showSearch
											/>
										</Form.Item>
									</Col>
									<Col span={4}>
										<Form.Item
											{...restField}
											name={[name, "measurementUnit"]}
											label="Measurement Unit"
											rules={[
												{
													required: true,
													message: "Missing unit",
												},
											]}
										>
											<Select
												style={{
													width: "100%",
												}}
												size="large"
												placeholder="Please select unit"
												options={[{ value: "ton", label: "ton" }]}
												disabled
												optionFilterProp="children"
												filterOption={filterOption}
												allowClear={false}
												showSearch
											/>
										</Form.Item>
									</Col>
									<Col span={2}>
										<MinusCircleOutlined
											onClick={() => {
												onRemoveItem(remove, name);
											}}
											disabled={loading}
										/>
									</Col>
								</Row>
							))}
							<Form.Item>
								<Button
									type="dashed"
									onClick={() => add()}
									block
									loading={loading}
									disabled={loading}
									icon={<PlusOutlined />}
								>
									Add Material
								</Button>
							</Form.Item>
						</>
					)}
				</Form.List>
				<Button
					type="primary"
					htmlType="submit"
					loading={loading}
					disabled={loading}
					size="large"
				>
					Create
				</Button>
			</Form>
			{contextHolder}
		</Modal>
	);
};

export default AddMaterialDeliveredModal;
